import React, {useState} from 'react';
import {Button, Card, Form, Grid, Popup} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {useDispatch, useSelector} from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {noTimeZoneFullISODate} from '../../../common/constants/datesFormat';
import {mapListToDropdownList} from '../../utils/commonUtils';

const {
  clearFloatingInventoryReport,
  fetchFloatingInventoryReport,
} = Actions;

const initialData = {
  'dateFrom': null,
  'dateTo': null,
  'dealer': '',
  'model': '',
  'katashiki': '',
  'order': '',
};

const SearchFloatingInventory = ({
  setResetAllFilters,
}) => {
  const dispatch = useDispatch();
  const listDealers = useSelector((state) => state.dealer.list);
  const [data, setData] = useState(initialData);
  const vehiclesList = useSelector((state) => state.vehiclesModelsList.list);
  const ordersList = useSelector((state) => state.floatingInventoryReport.listOrders);
  const dealerId = useSelector((state) => state.session.dealerId);
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(fetchFloatingInventoryReport({
      'allLines': true,
      'dealerId': dealerId,
      ...data,
    }));
  };
  const handleChange = (e, {name, value}) => {
    setData({...data, [name]: value});
  };

  const handleCleanFilters = () => {
    setData(initialData);
    setResetAllFilters(true);
    dispatch(clearFloatingInventoryReport());
  };

  return (
    <Card fluid>
      <Form size={'small'}>
        <Grid
          stackable
          fluid
          className='no-space w-100'
          textAlign='left'
          columns={1}>
          <Grid.Row width={16} columns={6} className='floating-report-spacig-search'>
            <Grid.Column width={2}>
              <DatePicker
                required
                name='dateFrom'
                placeholderText='SELECCIONAR...'
                showYearDropdown
                selected={data.dateFrom ? moment(data.dateFrom, noTimeZoneFullISODate).toDate() : null}
                onChange={(value) => handleChange(
                  null,
                  {
                    'name': 'dateFrom',
                    'value': moment(value).format(noTimeZoneFullISODate),
                  }
                )}
                customInput={
                  <Form.Input
                    icon='calendar'
                    className='small-label-custom calendar-input-floating floating-inventory-full-width'
                    size='mini'
                    label='DESDE:'
                  />
                }
                locale='es'
              />
            </Grid.Column>
            <Grid.Column width={2}>
              <DatePicker
                required
                name='dateTo'
                placeholderText='SELECCIONAR...'
                showYearDropdown
                selected={data.dateTo ? moment(data.dateTo, noTimeZoneFullISODate).toDate() : null}
                onChange={(value) => handleChange(
                  null,
                  {
                    'name': 'dateTo',
                    'value': moment(value).format(noTimeZoneFullISODate),
                  }
                )}
                customInput={
                  <Form.Input
                    icon='calendar'
                    className='small-label-custom calendar-input-floating floating-inventory-full-width'
                    size='mini'
                    label='HASTA:'
                    placeholder=' - '
                  />
                }
                locale='es'
              />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Select
                label='DEALER'
                className='selector-tiny-size small-label-custom'
                placeholder='SELECCIONAR...'
                name='dealer'
                size='mini'
                search
                value={data.dealer}
                onChange={handleChange}
                noResultsMessage='No se encontraron resultados...'
                options={mapListToDropdownList(
                  listDealers,
                  {
                    'keys': ['identification'],
                    'values': ['identification'],
                    'texts': ['name'],
                  }, true)}
              />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Select
                label='MODELO'
                className='selector-tiny-size small-label-custom'
                placeholder='SELECCIONAR...'
                name='model'
                size='mini'
                search
                value={data.model}
                onChange={handleChange}
                noResultsMessage='No se encontraron resultados...'
                options={mapListToDropdownList(
                  vehiclesList,
                  {
                    'keys': ['suffix', 'masterCode'],
                    'values': ['suffix', 'masterCode'],
                    'texts': ['carModel'],
                  }, true, '/')}
              />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Select
                label='KATASHIKI'
                className='selector-tiny-size small-label-custom floating-inventory-full-width'
                placeholder='SELECCIONAR...'
                name='katashiki'
                size='mini'
                search
                value={data.katashiki}
                onChange={handleChange}
                noResultsMessage='No se encontraron resultados...'
                options={mapListToDropdownList(
                  vehiclesList,
                  {
                    'keys': ['masterCode'],
                    'values': ['masterCode'],
                    'texts': ['masterCode'],
                  }, true)}
              />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Select
                label='PEDIDO'
                className='selector-tiny-size small-label-custom floating-inventory-full-width'
                placeholder='SELECCIONAR...'
                name='order'
                size='mini'
                search
                value={data.order}
                onChange={handleChange}
                noResultsMessage='No se encontraron resultados...'
                options={mapListToDropdownList(
                  ordersList,
                  {
                    'keys': ['orderNumber'],
                    'values': ['orderNumber'],
                    'texts': ['orderNumber'],
                  }, true)}
              />
            </Grid.Column>
            <Grid.Column width={4} className='floating-report-button-container'>
              <Button
                type='button'
                size='mini'
                basic
                compact
                color='grey'
                className='floating-report-clean-filters-button'
                onClick={handleCleanFilters}
              >
                LIMPIAR FILTROS
              </Button>
              <Popup
                trigger={
                  <span>
                    <Button
                      type='button'
                      size='mini'
                      compact
                      color='grey'
                      onClick={handleSubmit}
                      primary
                      disabled={!(data.dateFrom && data.dateTo)}
                    >
                      BUSCAR
                    </Button>
                  </span>
                }
                content={'Seleccione un rango de fechas válido.'}
                position='top center'
                size='small'
                style={{'maxWidth': '150px'}}
                inverted
                disabled={data.dateFrom && data.dateTo}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    </Card>
  );
};


export default SearchFloatingInventory;
